import { forwardRef, lazy, Suspense } from "react";
import type { IControlledCodeMirror, IUnControlledCodeMirror } from "react-codemirror2";
import type { CodeEditorProps } from "./code-editor-impl";

export type { CodeEditorProps };

// react-codemirror2 + codemirror and its modes/addons/CSS (~515 KB) are the
// single heaviest dependency in the app, but the ONLY things that render a
// CodeEditor are the project config editors (Settings > Quality, Create
// Project > Config). The @humansignal/ui barrel re-exports this component, so
// a static import used to drag all of codemirror into the first-paint bundle
// for EVERY visitor — including annotators who only ever label and never open
// a config.
//
// Split the codemirror-carrying implementation into its own chunk, loaded on
// first render via React.lazy. The barrel keeps only this thin wrapper (no
// codemirror); the heavy chunk arrives when — and only when — a config editor
// actually mounts. The type-only imports above are erased at build time, so
// they don't pull codemirror back in.
const CodeEditorImpl = lazy(() => import("./code-editor-impl"));

export const CodeEditor = forwardRef<unknown, CodeEditorProps & (IControlledCodeMirror | IUnControlledCodeMirror)>(
  (props, ref) => (
    <Suspense fallback={<div aria-busy="true" />}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <CodeEditorImpl {...(props as any)} ref={ref as any} />
    </Suspense>
  ),
);

export default CodeEditor;
